import { useParams } from "react-router-dom";

// a function to add url params into route components;
function RoutedComponent<T>({ render }: { render: (prop: T) => JSX.Element }) {
  const params = useParams() as unknown as T;
  return render(params) 
}

export default RoutedComponent;
